import * as AppBar from "./AppBar";

export const Breadcrumb_Search = "/ Search";
export const Breadcrumb_Create_Txt = "/ Create Asset";
export const Breadcrumb_Notifications_Txt = "/ Notifications";
export const Breadcrumb_Results_Txt = "Search Results";
export const Breadcrumb_ManageAsset_Txt = "Manage Asset";
export const Breadcrumb_ManageProduct_Txt = "Manage Product";

export const breadcrumbNameMap = {
  [AppBar.Search_Root_NavLink_To]: Breadcrumb_Search,
  [AppBar.Search_Alt_NavLink_To]: Breadcrumb_Search,
  [AppBar.Results_NavLink_To]: Breadcrumb_Results_Txt,
  [AppBar.Create_NavLink_To]: Breadcrumb_Create_Txt,
  [AppBar.Notifications_NavLink_To]: Breadcrumb_Notifications_Txt,
  [AppBar.ManageAssets_NavLink_To]: Breadcrumb_ManageAsset_Txt,
  [AppBar.ManageProducts_NavLink_To]: Breadcrumb_ManageProduct_Txt,
};
